import React, { Suspense } from "react";
import { ThemeProvider } from "@/context/ThemeContext";
import { LiveScoresProvider } from "@/context/LiveScoresContext";
import ReactDOM from "react-dom/client"; // Import from 'react-dom/client'
import BangkeoMain from "@/components/shortcode/Bangkeo";
import StandingFilter from "@/components/client/StandingFilter";
import { store } from "./lib/redux/store";
import { Provider } from "react-redux";
import "./index.css";
import LichThiDauPlugin from "./components/client/LichThiDauPlugin";
import KetQuaPlugin from "./components/client/KetQuaPlugin";
import ThongTinTranDauPlugin from "./components/client/ThongTinTranDauPlugin";
import { BrowserRouter } from "react-router-dom";
import StandingTopScoresFilter from "./components/client/StandingTopScoresFilter";
import {
  StandingFifaMenFilter,
  StandingFifaWomenFilter,
} from "./components/client/StandingFifaMenFilter";

const isReactBuild = process.env.REACT_APP_BUILD_TARGET === "react";

if (isReactBuild) {
  renderApps("keobongvip-root");
}

const componentMap = {
  bangkeo: BangkeoMain,
  bangxephang: StandingFilter,
  topghiban: StandingTopScoresFilter,
  bangxephangfifanam: StandingFifaMenFilter,
  bangxephangfifanu: StandingFifaWomenFilter,
  lichthidau: LichThiDauPlugin,
  ketqua: KetQuaPlugin,
  thongtintrandau: ThongTinTranDauPlugin,
};

function App({ league, type }) {
  const Component = componentMap[type] || (() => <div>Unknown type</div>);
  return <Component league={league} />;
}

function renderApps(className) {
  const rootElements = document.getElementsByClassName(className);

  Array.from(rootElements).forEach((rootElement) => {
    const type = rootElement.getAttribute("data-type");
    const league = rootElement.getAttribute("data-league");
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <Suspense fallback={<p>Loading...</p>}>
        <Provider store={store}>
          <ThemeProvider>
            <BrowserRouter>
              <LiveScoresProvider>
                <App type ={type} league={league} />
              </LiveScoresProvider>
            </BrowserRouter>
          </ThemeProvider>
        </Provider>
      </Suspense>
    );
  });
}
